import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScubaDivingTank = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-scuba-diving-tank",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M8 11a4 4 0 1 1 8 0v5h-8z" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 16v3a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-3" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 4h6" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 7v-3" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 4,
			r: .5,
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgScubaDivingTank);
export default ForwardRef;
